module.exports = __webpack_public_path__ + "img/07.db82ad54.png";